import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PaymentRequestStatus } from 'app/shared/models/payment-request-status.model';
import { PaymentRequestService } from 'app/shared/services/payment-request.service';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-payment-request-status-selection-list',
  templateUrl: './payment-request-status-selection-list.component.html',
  styleUrls: ['./payment-request-status-selection-list.component.scss']
})

export class PaymentRequestStatusSelectionListComponent implements OnInit {
  @Input() hideLabel: boolean = false;
  @Input() selectStatusText: string
  @Input() selectedPaymentRequestStatus: PaymentRequestStatus;
  @Output() paymentRequestStatusChangedEvent: EventEmitter<PaymentRequestStatus> = new EventEmitter<PaymentRequestStatus>();

  paymentRequestStatusList$: Observable<PaymentRequestStatus[]>;
  paymentRequestStatusListLoading = false;
  paymentRequestStatusListInput$ = new Subject<string>();

  constructor(private paymentRequestService: PaymentRequestService) {
  }

  ngOnInit() {
    this.loadPaymentRequestStatusList();
  }

  private loadPaymentRequestStatusList() {
    this.paymentRequestStatusList$ = this.paymentRequestService.getList<PaymentRequestStatus>("/payment-request/status/list");
  }

  selectedPaymentRequestStatusChanged(paymentRequestStatus: PaymentRequestStatus) {
    this.paymentRequestStatusChangedEvent.emit(paymentRequestStatus);
  }
}
